export const loginComponent = {
  template:
    '<auto-post-form options="vm.xeroxSsoLoginInfo" ng-if="vm.xeroxSsoLoginInfo"></auto-post-form>',
  controllerAs: "vm",
  controller: class loginController {
    /*@ngInject*/
    constructor(
      commonService,
      xeroxSsoService,
      ssoClientService,
      apiClientService,
      persistService,
      $state
    ) {
      this.commonService = commonService;
      this.xeroxSsoService = xeroxSsoService;
      this.ssoClientService = ssoClientService;
      this.apiClientService = apiClientService;
      this.persistService = persistService;
      this.$state = $state;
    }
    async $onInit() {
      const params = new URLSearchParams(window.location.search);
      let accountCountry = "us";
      const xAccountCountry = params.get("x-account-country");
      if (xAccountCountry) {
        accountCountry = xAccountCountry.toLowerCase();
      }
      this.persistService.setObject("accountCountry", accountCountry);

      this.xeroxSsoLoginInfo = await this.xeroxSsoService.getLoginModel();
      this.commonService.updateView();

      if (!this.xeroxSsoLoginInfo) {
        const clioToken = this.persistService.getObject("clioTokenData", true);
        const authStatus = await this.ssoClientService.getAuthStatus(clioToken);

        if (!authStatus) {
          this.$state.go("redirect");
        } else {
          if (authStatus != clioToken)
            this.ssoClientService.setTokenLocally(authStatus);

          this.apiClientService.setTokenAuthHeader(
            authStatus.access_token,
            accountCountry
          );
          this.$state.go("main");
        }
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/login.component.js